export default "__VITE_ASSET__DRGyDfjg__"